<template lang="pug">
  div.lmm-content-body-padded
    b-container(fluid)
      b-row
        b-col.page-wrap(cols="12")
          div(slot="header").d-flex.justify-content-between.page-header
            b-container.d-flex.justify-content-between(fluid)
              div
                span.page-title {{$t('deleted_device_history')}}
          b-container(fluid)
            b-row
              b-card.w-100(no-body)
                b-table(
                  ref="dataTable",
                  :fields="fields",
                  :items="items",
                  :current-page="page.current",
                  :per-page="page.per",
                  :show-empty="true",
                  tbody-class="lmm-table-body",
                  :empty-text="$t('no-content')")
                  template(slot="HEAD_name", slot-scope="data")
                    | {{$t('user')}}
                  template(slot="HEAD_reg_mail", slot-scope="data")
                    | {{$t('ID')}}
                  template(slot="HEAD_act_time", slot-scope="data")
                    | {{$t('delete_time')}}
                  template(v-slot:cell(new_value)="row")
                    | {{row.item.new_value === '1' ? '-' : row.item.new_value}}
                  template(v-slot:cell(act_time)="row")
                    | {{row.item.act_time | moment('add', AppState.Info.timezoneOffset, 'YY/MM/DD HH:mm')}}
                div.d-flex.justify-content-between(slot="footer")
                  div
                    b-form-select(
                      size="sm",
                      v-model="page.per",
                      :options="page.perOptions")
                  b-pagination(
                    size="sm",
                    :total-rows="page.total",
                    :per-page="page.per",
                    v-model="page.current",
                    class="my-0 float-right"
                  )
</template>

<script>
import _ from 'lodash'
import {AnalysticAPI} from '../../api'

export default {
  name: 'log-delete-component',
  methods: {
    startDateChanged (date) {
      this.range.start = date
      this.range.disabledDates.to = date
    },
    endDateChanged (date) {
      this.range.end = date
    },
    tableRefresh () {
      this.page.current = 1
      this.$refs.dataTable.refresh()
    },
    items (ctx) {
      let params = {
        by: 'create_time',
        q: 13,
        // start_date: moment(this.range.start).format('YYYY-MM-DD'),
        // end_date: moment(this.range.end).format('YYYY-MM-DD'),
        limit: ctx.perPage,
        offset: ctx.perPage * (ctx.currentPage - 1),
        order: 'desc'
      }
      return AnalysticAPI.history.get('audit', {params})
        .then(resp => {
          this.page.total = resp.data.meta.total_count
          return _.filter(resp.data.objects, v => v.pk !== 'EMPTY')
        })
    }
  },
  data () {
    return {
      fields: [
        {
          key: 'new_value',
          label: this.$t('agent'),
          sortable: false,
          tdClass: 'text-center',
          thClass: 'text-center'
        },
        {
          key: 'name',
          label: this.$t('user'),
          sortable: false,
          tdClass: 'text-center',
          thClass: 'text-center'
        },
        {
          key: 'reg_mail',
          label: this.$t('ID'),
          sortable: false,
          tdClass: 'text-center',
          thClass: 'text-center'
        },
        {
          key: 'act_time',
          label: this.$t('date'),
          sortable: false,
          tdClass: 'text-center',
          thClass: 'text-center'
        }
      ],
      page: {
        total: 0,
        current: 1,
        per: 10,
        perOptions: [
          { value: 5, text: '5' },
          { value: 10, text: '10' },
          { value: 15, text: '15' },
          { value: 20, text: '20' }
        ]
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.lmm-content-body-padded {
  padding: 0;
  margin: 0;
}

.row, .col, .container-fluid, .container {
  margin: 0;
  padding: 0;
}

.page-wrap {
  padding: 1rem 1.5rem;
}

.page-header {
  padding: 0 1.5rem 0 1.5rem;
  margin-bottom: 0.5rem;
}

.card {
  border-radius: 0;
  .card-body {
    padding: 0;
  }
}

::v-deep .b-table {
  margin: 0;
  tr, td, th {
    padding: 0.5rem 0 0.5rem 1rem;
    position: relative;
    font-weight: 400;
  }
  th:nth-child(1), th:nth-child(2), th:nth-child(3) {
    position: relative;
    padding-right: 0;
    text-align: left !important;
    width: 15% !important;
  }
  th:nth-child(4) {
    text-align: left !important;
  }
  td:nth-child(1), td:nth-child(2), td:nth-child(3), td:nth-child(4) {
    position: relative;
    padding-right: 0;
    text-align: left !important;
    color: #6F6F6F;
  }
}

::v-deep .form-control, .custom-select {
  display: flex;
  background-color: #FFFFFF !important;
  border: 1px solid #6F6F6F !important;
  border-radius: 0;
  height: 1.75rem;
  align-items: center;
  text-align: left !important;
}
</style>
